export const DOMAINS = [
  { key: "Leadership", score: 3.4, blurb: "Clarity of accountability, decision-making, and leadership cadence." },
  { key: "Scheduling & Dispatch", score: 2.6, blurb: "Capacity planning, scheduling discipline, and on-time execution." },
  { key: "Operations & Field Execution", score: 3.1, blurb: "Standardized workflows, quality control, and doing it right the first time." },
  { key: "Finance", score: 2.9, blurb: "Job costing, margin visibility, and cash discipline." },
  { key: "Customer Experience", score: 3.6, blurb: "Response, communication, and customer retention." },
  { key: "Technology", score: 2.4, blurb: "Systems of record, data flow, and automation." },
  { key: "Continuous Improvement", score: 2.2, blurb: "Problem-solving cadence and improvement culture." },
];

export const MATURITY = [
  { level: 1, label: "Ad Hoc", desc: "Ad-hoc and owner-driven" },
  { level: 2, label: "Emerging", desc: "Some process, inconsistent" },
  { level: 3, label: "Defined", desc: "Documented and repeatable" },
  { level: 4, label: "Managed", desc: "Measured and improving" },
  { level: 5, label: "Optimizing", desc: "Scales without the owner" },
];

// The operating journey: Understand → Diagnose → Prioritize → Implement.
export const JOURNEY = [
  { n: "01", title: "Understand", desc: "A working conversation about how the business actually runs — where the owner is the bottleneck, and what growth is straining." },
  { n: "02", title: "Diagnose", desc: "The Operational Performance Assessment builds an evidence-based view of operational health across seven domains." },
  { n: "03", title: "Prioritize", desc: "Findings are ranked by business impact — what deserves attention first, not a generic transformation list." },
  { n: "04", title: "Implement", desc: "An Operational Performance Partnership translates the prioritized roadmap into execution, at the pace the business can absorb." },
];

export const PILLARS = [
  "Executive-level operational leadership",
  "The Local Proof Method™",
  "Structured assessment methodology",
  "Practical implementation",
  "Continuous improvement",
  "AI-enabled research",
  "Leadership alignment",
  "Data-informed decision making",
];

export const MANIFESTO = [
  "Businesses should scale through systems — not through the owner.",
  "Execution beats strategy that never ships.",
  "Make the numbers visible and the problems safe.",
  "Every engagement begins with understanding.",
  "Improvement is a habit, not an event.",
];

// Canonical public offer architecture (current operating doctrine).
// OPA is the primary public starting point; OPP is the implementation
// relationship. No public pricing is published until ratified by the Founder.
export const OFFERS = [
  {
    slug: "assessment",
    name: "Operational Performance Assessment",
    tagline: "See your business clearly.",
    price: "",
    desc: "An evidence-based view of operational health. We assess the seven domains that decide whether a business can scale, and deliver a clear picture of what deserves attention first — not a generic consulting report.",
    outcomes: [
      "Executive Business Health Scorecard across 7 domains",
      "Prioritized operational findings tied to business impact",
      "A practical 90-day roadmap",
      "An executive findings readout",
    ],
    deliverables: ["Business Health Scorecard", "Prioritized findings", "90-day roadmap", "Executive readout"],
    ideal: "Established, owner-led service businesses whose growth has begun to outpace their operating systems.",
  },
  {
    slug: "partnership",
    name: "Operational Performance Partnership",
    tagline: "Implement what the assessment revealed.",
    price: "",
    desc: "The optional implementation relationship that follows the assessment. We work alongside your leadership to translate the prioritized findings into execution — installing the systems, visibility, and operating discipline the roadmap calls for.",
    outcomes: [
      "Implementation follows identified priorities",
      "Leadership operating cadence installed",
      "Standardized workflows and systems of record",
      "Progress measured against the scorecard",
    ],
    deliverables: ["Prioritized implementation support", "Playbooks & SOPs", "KPI visibility", "Operating cadence"],
    ideal: "Owners who have their assessment findings and want a disciplined partner to execute against them.",
  },
];

// Home-page summary: the primary entry offer and the relationship it can lead to.
export const OFFER_PATH = [
  {
    slug: "assessment",
    stage: "Start here",
    name: "Operational Performance Assessment",
    desc: "An evidence-based view of operational health — a Business Health Scorecard, prioritized findings, and a practical 90-day roadmap.",
  },
  {
    slug: "partnership",
    stage: "Then implement",
    name: "Operational Performance Partnership",
    desc: "The optional implementation relationship that turns prioritized findings into installed systems — at the pace your business can absorb.",
  },
];

// Contact form interest options — blank default, intentional selection.
export const OFFER_TYPES = [
  "Operational Performance Assessment",
  "Operational Performance Partnership",
  "General Inquiry",
];
